import { Checkbox, Form, Select, message, Typography, Tooltip } from 'antd';
import { useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { QuestionCircleOutlined } from '@ant-design/icons';

const AdvanceSettings = (props: any) => {
  const { onSubmit, submited, onChange, userInfo, spaceData, spaceEntitlements } = props
  const  { t } = useTranslation();


  const handleFormChange = (changedValues: any, allValues: any) => {
    const changedFields = Object.keys(changedValues);
    const hasChanges = changedFields.some(field => allValues[field] !== spaceData[field]);
    if (hasChanges && spaceEntitlements.includes("Space_Advanced_Update")) {
      onChange()
    }
  }

  return (
    <div style={{ background: "#fff", borderRadius: "1rem" }}>
      <div className="space-setting" >
        <div className="space-heading" >{t("Advanced Settings")}</div>
        {/* <Form form={form} style={{ width: '100%' }} name="space-settings-form" size="large" onFinish={onFinish} layout='vertical' initialValues={{...spaceData}}
          onValuesChange={handleFormChange}>
      </Form> */}
      <Form.Item
          label=""
          name="allowAllAccess"
          valuePropName="checked"
        >
          <Checkbox className="custom-checkbox" >
            {t("Allow users to access all requests")}
            <Tooltip title={t("Allow anyone in the space to view all requests, even if they are not added as contributors")}>
              <QuestionCircleOutlined style={{ marginLeft: 4, color: "#00000073" }} />
            </Tooltip>
          </Checkbox>
        </Form.Item>
        <Form.Item name="allowedDuplicate" valuePropName="checked">
          <Checkbox className='custom-checkbox'>{t("Allow duplication of approval request")}</Checkbox>
        </Form.Item>
        <Form.Item name="enableRequestCopyWithKeyValue" valuePropName="checked">
          <Checkbox className='custom-checkbox'>{t("Enable request copying using key-value")}</Checkbox>
        </Form.Item>
        <Form.Item name="enableChatroom" valuePropName="checked" >
          <Checkbox value="true" className='custom-checkbox' >{t("Enable comments")}</Checkbox>
        </Form.Item>
        <Form.Item name="allowShareToExternalUser" valuePropName="checked">
          <Checkbox className='custom-checkbox'>
            {t("Allow sharing to external users")}
            <Tooltip title={t("Allow requests in this space to be shared with users outside the organization")}>
              <QuestionCircleOutlined style={{ marginLeft: 4, color: "#00000073" }} />
            </Tooltip>
          </Checkbox>
        </Form.Item>
        <Form.Item name="allowFormsReversal" valuePropName="checked">
          <Checkbox className='custom-checkbox'>
            {t("Allow forms reversal")}
            <Tooltip title={t("Reverse the sequence of the approved workflow forms in the request approval process")}>
              <QuestionCircleOutlined style={{ marginLeft: 4, color: "#00000073" }} />
            </Tooltip>
          </Checkbox>
        </Form.Item>
      </div>
    </div>
  )
}

export default AdvanceSettings;